import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { Control, Controller } from 'react-hook-form';
import Select from 'react-select';
import FormFieldTitle from './FormFieldTitle';

interface DropdownField {
  key: string;
  label: string;
  defaultValue?: string;
  options: string;
  required: boolean;
}
interface SingleDropdownProps {
  field: DropdownField;
  control?: Control<any>;
  editable?: boolean;
  Ctrl?: typeof Controller;
  errors?: any;
  changeEvent?: any;
  choices?: any;
  isDisabled?: boolean;
  //parent?:string;
}

const ReactDropdownSingleSelect: React.FC<SingleDropdownProps> = ({
  field,
  control,
  editable,
  Ctrl,
  errors,
  changeEvent,
  choices,
  isDisabled=false,
}) => {
  const rule = field.required ? { required: field.label + ' is required' } : { required: false };
  const [items, setItems] = useState<{ label: string; value: string; key: string }[]>([]);

  useEffect(() => {
    const options = choices ?? field.options ?? "";
    const parsed =
      options.includes("#;#")
        ? options.split("#;#").map((item: string, index: number) => ({
            label: item.trim(),
            value: item.trim(),
            key: index.toString(),
          }))
        : [{ label: options.trim(), value: options.trim(), key: "0" }];

    setItems(parsed);
  }, [field.options, choices]);

  const sharedInputStyles = {
    backgroundColor: "transparent",
    borderWidth: 1,
    borderColor: "gray",
    borderRadius: 5,
    minHeight: 60,
    maxHeight: 60,
  };

  return (
    <View style={{ flexDirection: "column", paddingTop: 6 }}>
      <View style={{ width: "100%" }}>{<FormFieldTitle field={field} />}</View>

      <View style={[styles.container, editable && sharedInputStyles, { paddingTop: 0 }]}>
        {editable === false ? (
          <Text style={{ fontWeight: "normal", fontSize: 12 }}>
            {field.defaultValue ?? null}
          </Text>
        ) : (
          <Ctrl
            key={field.key}
            control={control}
            name={field.key}
            rules={rule}
            defaultValue={field.defaultValue && field.defaultValue}
            render={({ field: { onChange, value } }) => (
              <Select
                options={items}
                isMulti={false}
                value={items.find((opt) => opt.value === value) || null} // 🔑 derived from hook form
                onChange={(selected: { value: any; }) => {
                  onChange(selected?.value ?? ""); // update form state
                  changeEvent && selected?.value && changeEvent(selected.value);
                }}
                styles={{
                  menu: (provided: any) => ({
                    ...provided,
                    backgroundColor: "rgb(247, 243, 249)",
                    zIndex: 100,
                  }),
                  control: (base: any) => ({
                    ...base,
                    borderWidth: 0,
                    boxShadow: "none",
                  }),
                  menuPortal: (provided: any) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
                menuPortalTarget={document.body}
                isDisabled={isDisabled}
              />
            )}
          />
        )}
      </View>
      {errors[field.key]?.message && (
        <Text style={{ color: "red" }}>{errors[field.key]?.message}</Text>
      )}
    </View>
  );
};


const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#ffffff',
    justifyContent: 'center',
  },
});

export default ReactDropdownSingleSelect;
